"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Popup_1 = require("./Popup");
exports.Popup = Popup_1.default;
//# sourceMappingURL=main.js.map


//////////////////
// WEBPACK FOOTER
// /Users/larsmarin/Documents/Workspaces/AAG/aag-amc-projects/~/.pnpm/@progress+kendo-react-popup@3.18.0_react-dom@16.14.0_react@16.14.0__react@16.14.0/~/@progress/kendo-react-popup/dist/npm/main.js
// module id = 47
// module chunks = 0